import templateUrl from "emun.prospect/prospect-list.htm";
import basicController from "servicestack/basic.controller.properties";
import prospectConfig from "emun.prospect/prospect.config";
import activityConfig from "emun.activity/activity.config";

export const filters = prospectConfig.filters;

export class ProspectListController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
  }

  $onInit() {
    const $ctrl = this;

    $ctrl.bus = $ctrl.container.bus;
    $ctrl.rootScope = $ctrl.container.rootScope;
	  $ctrl.customerConfig = $ctrl.container.customerConfig;
    $ctrl.activityConfig = activityConfig;
    $ctrl.prospectConfig = prospectConfig;
    $ctrl.rootScope = $ctrl.container.rootScope;
    $ctrl.prompt = $ctrl.container.prompt;
    $ctrl.query = $ctrl.container.query;
    $ctrl.refreshTotals = $ctrl.container.refreshTotals.bind($ctrl.container);
    $ctrl.load = $ctrl.container.load.bind($ctrl.container);
    $ctrl.deleteProspect = $ctrl.container.deleteProspect.bind($ctrl.container);
    $ctrl.refreshTotals = $ctrl.container.refreshTotals.bind($ctrl.container);
    $ctrl.add = $ctrl.container.add.bind($ctrl.container);
    $ctrl.setStatus = $ctrl.container.setStatus.bind($ctrl.container);
    $ctrl.toggleHot = $ctrl.container.toggleHot.bind($ctrl.container);
  }
}

export default {
  bindings: {},
  require: {
    container: "^prospectContainer",
  },
  controller: ProspectListController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
